import * as React from 'react'
import { MenuItem, Select, Button } from '@material-ui/core'

import _ from 'lodash'
import { useDispatch } from 'react-redux'

import { Device } from '../../types'
import { downloadCSV } from './operations'

type Props = {
  device: Device
}

function LogExportForm({ device }: Props) {
  const dispatch = useDispatch()

  const dates: { [ymd: string]: number } = {}

  _.forEach(device.logCounts, (v, ym) => {
    _.forEach(v, (n, d) => {
      dates[ym + '-' + d] = n
    })
  })
  const [date, setDate] = React.useState<string>('---')

  return (
    <div>
      <Select
        value={date}
        onChange={e =>
          typeof e.target.value === 'string' && setDate(e.target.value)
        }
        inputProps={{ name: 'date' }}
      >
        <MenuItem value={'---'}>---</MenuItem>
        {_.map(dates, (n, date) => (
          <MenuItem key={date} value={date}>
            {date}({n})
          </MenuItem>
        ))}
      </Select>
      <Button
        variant="contained"
        disabled={date === '---'}
        onClick={() => {
          dispatch(downloadCSV(device.id, date))
        }}
      >
        Export
      </Button>
    </div>
  )
}
export default LogExportForm
